import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/csg-logo-larger.png';
import './AuthPage.scss';

export default function AuthPage({ children, title, style })
{
    return (
        <div className='auth-page' style={style}>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-10 offset-1 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4'>
                        <img src={logo} className='auth-page-logo' alt="auth-page-logo"/>
                        
                        <div className='auth-page-content'>
                            {
                                title ? 
                                    <div className='auth-page-title'>
                                        <h3>{title}</h3>
                                    </div>
                                : null
                            }
                            
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>   
    )
}

export function AuthLink(props)
{
    return (
        <Link className='auth-page-link' {...props}/>
    )
}